import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n";
const currentLanguage = localStorage.getItem("language") || "en";
export const editQuestioneir = createAsyncThunk(
    "questionier/editQuestioneir", 
    async (values ) => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post(
          `https://secretvisitor.co/dashboard/api/editQuestionAdmin`, 
          {questions:values ,question_id:values[0].id},
          { headers: {"Authorization" : token , "lang" : currentLanguage ,}}
        );
        return response.data ;
      } catch (error) {
        console.error(error);
      }
});
export const deleteQuestioneir = createAsyncThunk(
    "questionier/deleteQuestioneir", 
    async (values ) => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post(
          `https://secretvisitor.co/dashboard/api/deleteQuestionAdmin`, 
          {question_id:values[0].id},
          { headers: {"Authorization" : token , "lang" : currentLanguage ,}}
        );
        return response.data ;
      } catch (error) {
        console.error(error);
      }
});
export const sendQuestioneir = createAsyncThunk(
    "questionier/sendQuestioneir", 
    async (values) => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.post(
          `https://secretvisitor.co/dashboard/api/addQuestionAdmin`, 
          {questions:values},
          { headers: {"Authorization" : token , "lang" : currentLanguage ,}}
        );
        return response.data ;
      } catch (error) {
        console.error(error);
      }
});
export const getQuestionnaire = createAsyncThunk(
  "questionnaire/getQuestionnaire", 
async (values) => {
  const token = localStorage.getItem('token');
    try {
    const response = await axios.get(
        `https://secretvisitor.co/dashboard/api/getQuestionsAdmin` ,{
            headers: {
                "Authorization" : token , 
                "lang" : currentLanguage ,
            },
        }
    );
    return response.data ;
    } catch (error) {
    console.error(error);
    }
}
);

const questionierSlice = createSlice({
    name: "questionier",
    initialState: {
        getQuestionnaireData : {} ,
        getQuestionnaireLoading : false , 
        questionieres:[],
        currentQuestioneir:-1,
        CurrentQuestioneirID : -1 ,  
        currentStep:0,
        isReadyToSend:false,
        questionierDataSent:{},
        focusedStep:-1,
        focusedQuestion:-1,
        questionierDataDelete:{}
    },
    reducers: {
        ToggleDirection: (state, action) => {
        state.direction = action.payload
        },
        setCurrentStep: (state, action) => {
            state.currentStep = action.payload
        },
    
        deleteStep: (state, action) => {
          state.questionieres[state.currentQuestioneir].steps.splice(action.payload, 1);
        },
        setCurrentQuestioneirID: (state, action) => {
          state.CurrentQuestioneirID += action.payload
        },
        setCurrentQuestioneir: (state, action) => {
            state.currentQuestioneir = action.payload
        },
        setNewQuestioneir: (state) => {
            state.questionieres.push({title:'',steps:[]}) 
            state.currentQuestioneir =state.questionieres.length-1
        },
        setNewQuestioneirName: (state ,action) => {
            state.questionieres[state.currentQuestioneir].title =action.payload
        },
        setNewStep: (state, action) => {
            console.log(state.questionieres[state.currentQuestioneir]);
            state.questionieres[state.currentQuestioneir].steps.push({name:action.payload ,questions:[]}) 
        },
        setNewStepName: (state ,action) => {
          state.questionieres[state.currentQuestioneir].steps[state.currentStep].name =action.payload
        },
        setQuestionsInStep: (state, action) => {
            const { type, insertIndex } = typeof action.payload === 'object' ? action.payload : { type: action.payload, insertIndex: null };
            const newQuestion = {type: type, title:'', required:'required', options:[]};
            
            console.log('setQuestionsInStep called with:', { type, insertIndex, payload: action.payload });
            
            if (insertIndex !== null && insertIndex !== undefined && insertIndex >= 0) {
                // Insert after the focused question (insertIndex + 1)
                const questions = state.questionieres[state.currentQuestioneir].steps[state.currentStep].questions;
                console.log('Inserting at index:', insertIndex + 1, 'Total questions:', questions.length);
                questions.splice(insertIndex + 1, 0, newQuestion);
            } else {
                // Default behavior: add to the end
                console.log('Adding to end');
                state.questionieres[state.currentQuestioneir].steps[state.currentStep].questions.push(newQuestion);
            }
        },
        handleDeleteQuestion: (state, action) => {
      
            state.questionieres[state.currentQuestioneir].steps[state.currentStep].questions.splice(action.payload, 1);
       
        },
        handleMoveQuestion: (state, action) => {
          console.log('nnnnnnnnn',action);
          const [movedQuestion] = state.questionieres[state.currentQuestioneir].steps[state.currentStep].questions.splice(action.payload.fromIndex, 1); // Remove the dragged question
          state.questionieres[state.currentQuestioneir].steps[state.currentStep].questions.splice(action.payload.toIndex, 0, movedQuestion)
        },
        handleMoveStep: (state, action) => {
          console.log('nnnnnnnnn',action);
          const [movedQuestion] = state.questionieres[state.currentQuestioneir].steps.splice(action.payload.fromIndex, 1); // Remove the dragged question
          state.questionieres[state.currentQuestioneir].steps.splice(action.payload.toIndex, 0, movedQuestion)
        },
        setFocusedStep: (state, action) => {
          state.focusedStep = action.payload

        },
        setFocusedQuestion: (state, action) => {
          state.focusedQuestion = action.payload
        },
        setQuestionDetails: (state, action) => {
            if(action.payload.data.required) {console.log(action.payload.data); state.questionieres[state.currentQuestioneir].steps[state.currentStep].questions[action.payload.index].required =action.payload.data.required;}
            else if(action.payload.data.title || action.payload.data.title === "" ) { console.log(action.payload.data);state.questionieres[state.currentQuestioneir].steps[state.currentStep].questions[action.payload.index].title =action.payload.data.title}
            else if(action.payload.data.options) {console.log(action.payload.data); state.questionieres[state.currentQuestioneir].steps[state.currentStep].questions[action.payload.index].options =action.payload.data.options}
          
       
        },
        handleReadyToSend: (state, action) => {
      
            state.isReadyToSend=action.payload
        },
       
      },

      extraReducers: (builder) => {
        builder
        .addCase(getQuestionnaire.fulfilled , (state, action) => {
          state.getQuestionnaireData = action.payload;
          if (state.getQuestionnaireData.status) {
            console.log ("bahaa " , state.getQuestionnaireData )
            state.questionieres = state.getQuestionnaireData.data.questions
            
          } 

          state.getQuestionnaireLoading = false;
        }) 
        .addCase(getQuestionnaire.pending, (state, action) => {
            state.getQuestionnaireLoading = true;
        }) 
        .addCase(getQuestionnaire.rejected , (state, action) => {
            state.getQuestionnaireLoading = false;
        })

          .addCase(sendQuestioneir.fulfilled, (state, action) => {
            state.questionierDataSent = action.payload;
           
          })
          .addCase(editQuestioneir.fulfilled, (state, action) => {
            state.questionierDataSent = action.payload;
           
          })
          .addCase(deleteQuestioneir.fulfilled, (state, action) => {
            state.questionierDataDelete = action.payload;
           
          })
         
      }
  });
  export const { 
    ToggleDirection ,
    setCurrentStep,
    deleteStep,
    setCurrentQuestioneir,
    setNewStep,
    setNewQuestioneir
    ,setQuestionsInStep,
    setNewStepName,
    handleReadyToSend,
    setQuestionDetails,
    setNewQuestioneirName,
    handleMoveQuestion,
    handleMoveStep,
    handleDeleteQuestion , 
    setFocusedStep,
    setFocusedQuestion,
    setCurrentQuestioneirID
} = questionierSlice.actions;
  export default questionierSlice.reducer;